import { useEffect } from 'react'
import {
    consumePendingAppUpdateNavigation,
    getAppUpdateNavigationTarget,
} from '../../utils/appUpdateMonitor'

const AppUpdateNavigationBridge = () => {
    useEffect(() => {
        const handleDocumentClick = (event: MouseEvent) => {
            const targetUrl = getAppUpdateNavigationTarget(event)

            if (!targetUrl) {
                return
            }

            if (consumePendingAppUpdateNavigation(targetUrl)) {
                event.preventDefault()
                event.stopPropagation()
            }
        }

        document.addEventListener('click', handleDocumentClick, true)

        return () => {
            document.removeEventListener('click', handleDocumentClick, true)
        }
    }, [])

    return null
}

export default AppUpdateNavigationBridge
